export const iconFontAwesomeGendersVenus = (
	<i className="fa-solid fa-venus"></i>
);
